/*
 * @Author: cts 308360781@qq.com
 * @Date: 2025-03-09 18:08:35
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2025-04-09 17:44:40
 * @FilePath: \qda.admin\src\utils\upload_utils.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import md5_util from "@/utils/md5_util.js";
import http from "@/http/axios_init";
import axios from "axios";

function handlerWH(file) {
  return new Promise((resolve) => {
    let img = new Image();
    img.onload = function () {
      file.width = img.width;
      file.height = img.height;
      resolve(file);
    };
    img.src = URL.createObjectURL(file);
  });
}

export default {
  /**
   * 上传图片文件
   * @param {*} file
   * @param {*} config
   */
  async uploadImage(file, config) {
    //获取md5值
    var md5 = await md5_util.fileMd5(file);
    //获取图片长宽
    await handlerWH(file);

    var model = {
      height: file.height,
      width: file.width,
      size: file.size,
      psd_type: 1,
      name: file.name,
      ext: `.${file.type.replace("image/", "")}`,
      md5: md5,
    };

    var res = await http.get("admin/v1/common/file/dtl?md5=" + md5);
    if (res.code == 0) {
      if (res.data) {
        return {
          file_url: res.data.file_url,
          ext: res.data.ext,
        };
      }
    }

    var res = await http.post("admin/v1/common/file/get_put_url", {
      bucket: "qda",
      ext: model.ext,
    });
    if (res.code == 0 && res.data) {
      var response = await axios.put(res.data.upload_url, file, {
        headers: { "content-type": file.type },
        onUploadProgress(m) {
        },
      });
      if (response.status == 200) {
        model.file_url = res.data.download_url;
        http.post("admin/v1/common/file/add", model);
        return {
          file_url: res.data.download_url,
          ext: model.ext,
        };
      }
    }

    throw "上传图片失败";
  },

/**
   * 上传视频文件
   * @param {*} file
   */
async uploadVideo(file) {
  //获取md5值
  var md5 = await md5_util.fileMd5(file);
  var model = {
    height: 0,
    width: 0,
    size: file.size,
    psd_type: 2,
    name: file.name,
    ext: `.${file.type.replace("video/", "")}`,
    md5: md5,
  };

  var res = await http.get("admin/v1/common/file/dtl?md5=" + md5);
  if (res.code == 0) {
    if (res.data) {
      return {
        file_url: res.data.file_url,
        ext: res.data.ext,
      };
    }
  }

  var res = await http.post("admin/v1/common/file/get_put_url", {
    bucket: "qda",
    ext: model.ext,
  });
  if (res.code == 0 && res.data) {
    var response = await axios.put(res.data.upload_url, file, {
      headers: { "content-type": file.type },
      onUploadProgress(m) {
      },
    });
    if (response.status == 200) {
      model.file_url = res.data.download_url;
      http.post("admin/v1/common/file/add", model);
      return {
        file_url: res.data.download_url,
        ext: model.ext,
      };
    }
  }

  throw "上传图片失败";
},
  
};
